/* =================================================================================================
 * Page « Nouvelle collection » — carrousel de photos.
 *
 * Le défilement est celui du navigateur : le doigt et le pavé tactile
 * fonctionnent sans intervention. Le script ne fait que deux choses — déplacer
 * ce défilement quand on clique une flèche, et estomper une flèche devenue
 * inutile en bout de course.
 *
 * ⚠️ Ne rien déclencher sur l'événement `scroll` autre que la mise à jour des
 * flèches : un défilement piloté qui se réagit à lui-même se met en boucle.
 * ===============================================================================================*/

(function () {
  'use strict';

  if (customElements.get('campus-slider')) return;

  class CampusSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.campus-slider__viewport');
      this.prev = this.querySelector('.campus-slider__arrow--prev');
      this.next = this.querySelector('.campus-slider__arrow--next');
      if (!this.viewport) return;

      if (this.prev) this.prev.addEventListener('click', () => this.deplacer(-1));
      if (this.next) this.next.addEventListener('click', () => this.deplacer(1));

      this.majFleches = this.majFleches.bind(this);
      this.viewport.addEventListener('scroll', this.majFleches, { passive: true });
      window.addEventListener('resize', this.majFleches);

      // Les images arrivent après le rendu et changent la largeur défilante,
      // donc l'état des flèches. Un simple délai ne suffit pas : sur une
      // connexion lente les deux flèches resteraient désactivées, et sur
      // ordinateur le carrousel deviendrait inutilisable. On suit donc le
      // chargement réel de chaque image, et les changements de taille.
      this.viewport.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', this.majFleches, { once: true });
        img.addEventListener('error', this.majFleches, { once: true });
      });

      if (window.ResizeObserver) {
        this.resize = new ResizeObserver(this.majFleches);
        this.resize.observe(this.viewport);
      }

      window.requestAnimationFrame(this.majFleches);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.majFleches);
      if (this.resize) this.resize.disconnect();
    }

    /** Largeur d'une vignette, écart compris. */
    pas() {
      var item = this.viewport.querySelector('.campus-slider__item');
      if (!item) return this.viewport.clientWidth;
      var ecart = parseFloat(window.getComputedStyle(this.viewport).columnGap) || 0;
      return item.getBoundingClientRect().width + ecart;
    }

    deplacer(sens) {
      var v = this.viewport;
      var max = v.scrollWidth - v.clientWidth;
      // En boucle : au bout, la flèche ramène à l'autre extrémité.
      if (this.hasAttribute('data-loop')) {
        if (sens > 0 && v.scrollLeft >= max - 2) { v.scrollTo({ left: 0, behavior: 'smooth' }); return; }
        if (sens < 0 && v.scrollLeft <= 2) { v.scrollTo({ left: max, behavior: 'smooth' }); return; }
      }
      v.scrollBy({ left: this.pas() * sens, behavior: 'smooth' });
    }

    majFleches() {
      var v = this.viewport;
      var reste = v.scrollWidth - v.clientWidth - v.scrollLeft;
      if (this.hasAttribute('data-loop')) {
        // En boucle, aucune flèche n'est jamais inutile.
        if (this.prev) this.prev.disabled = false;
        if (this.next) this.next.disabled = false;
        return;
      }
      if (this.prev) this.prev.disabled = v.scrollLeft <= 2;
      if (this.next) this.next.disabled = reste <= 2;
    }
  }

  customElements.define('campus-slider', CampusSlider);
})();
